import React, { useState } from 'react';

import { SearchFields } from './components/SearchFields';
import { SuccessAccordion } from './components/SuccessAccordion';
import { ErrorAccordion } from './components/ErrorAccordion';
import { ProcessingAccordion } from './components/ProcessingAccordion';
import './IntegratedDocumentsPage.css';

export function IntegratedDocumentsPage() {
  const [search, setSearch] = useState(false);
  const [elasticFilter, setElasticFilter] = useState([]);
  const [connectorFilter, setConnnectorFilter] = useState([]);
  const [connectorResponse, setConnectorResponse] = useState([]);

  const [data, setData] = useState([]);
  const dataSuccess = data.filter((el) => el.status === 'SUCCESS');

  const dataError = data
    ?.filter(
      (el) =>
        // eslint-disable-next-line implicit-arrow-linebreak, operator-linebreak
        el?.status !== 'SUCCESS' &&
        !dataSuccess.find(
          (e) => el.local_id === e.local_id
            && (el.cnes === e.cnes || el?.instance === e?.instance),
        ),
    )
    ?.map((e) => {
      const auxStatus = connectorResponse?.some(
        (process) =>
          // eslint-disable-next-line implicit-arrow-linebreak
          process?.documentId === e?.local_id && process?.status === 'created',
      );
      return { ...e, activeSolicitating: auxStatus };
    });

  return (
    <div style={{ margin: '0px 40px' }}>
      <h1 className="pageTitle integratedDocuments">
        Pesquisa de documentos integrados
      </h1>
      <SearchFields
        setSearch={setSearch}
        setData={setData}
        setConnnectorFilter={setConnnectorFilter}
        setElasticFilter={setElasticFilter}
        setConnectorResponse={setConnectorResponse}
      />

      <>
        {search && (
          <>
            <p className="titleIntegratedDocuments">
              Lista de resultados de documentos integrados
            </p>
            <SuccessAccordion
              data={data}
            />
            <ErrorAccordion
              data={dataError}
              connectorFilter={connectorFilter}
              elasticFilter={elasticFilter}
              setData={setData}
              setConnectorResponse={setConnectorResponse}
            />
            <ProcessingAccordion data={connectorResponse} />
          </>
        )}
      </>
    </div>
  );
}
